import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/Header/Header';
import PageTitle from '../../components/pagetitle/PageTitle';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/business/Footer/Footer';
import CtaSection from '../../components/CtaSection/CtaSection';
import Bg from '../../images/backgrounds/onze_diensten_image.webp';
import srImg from '../../images/services/quickscan/quickscan_info.webp';

const RequestComplianceConsult = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    };

    return (
        <Fragment>
            <Header />
            <main className="page_content about-page">
                <PageTitle pageTitle={'Compliance Consult'} bgImage={Bg} />

                {/* Introductie Section */}
                <section className="about_section section_space bg-light">
                    <div className="container">
                        <div className="row align-items-center justify-content-lg-between">
                            <div className="col-lg-5 order-lg-last">
                                <div className="team_cartoon_image">
                                    <img src={srImg} alt="Service Cartoon"/>
                                </div>
                            </div>
                            <div className="col-lg-5">
                                <div className="about_content">
                                    <div className="heading_block">
                                        <h2 className="heading_text">
                                            Waarom een Compliance Consult?
                                        </h2>
                                        <p className="heading_description mb-0">
                                            Elke organisatie staat voor unieke uitdagingen als het gaat om cybersecurity en compliance. Regelgevingen zoals de AVG (GDPR), ISO 27001, NIS2, en andere branche-specifieke normen vragen om een doordachte aanpak. Niet voldoen aan deze regelgeving kan leiden tot hoge boetes, reputatieschade en verlies van klantenvertrouwen.
                                        </p>
                                        <br></br>
                                        <p className="heading_description mb-0">
                                            Met onze Compliance Consult helpen wij uw organisatie inzicht te krijgen in de eisen en zorgen we ervoor dat u volledig voldoet aan de wetgeving. Ons doel is om compliance niet alleen een verplichting, maar ook een strategisch voordeel te maken.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>



                {/* Stappenplan Inplannen Training */}
                <section className="steps_section section_decoration mt-5 pt-5" style={{ paddingBottom: "150px" }}>
                    <div className="container">
                        <div className="heading_block text-center">
                            <h3 className="heading_text">Wat kunt u verwachten van het Compliance Consult?</h3>
                            <p className="heading_description mb-5">Tijdens ons consult bieden we</p>
                        </div>
                        <div className="row">
                            <div className="col-lg-6 col-md-12 mb-4">
                                <div className="step_card card">
                                    <div className="card-body text-center">
                                        <h4 className="card-title">1. Analyse van uw huidige situatie</h4>
                                        <p className="card-text">
                                            We beoordelen hoe uw organisatie momenteel presteert op het gebied van compliance en cybersecurity. Denk hierbij aan:
                                        </p>
                                        <ul className="card-text" style={{ textAlign: "left"}}>
                                            <li>Beveiligingsmaatregelen zoals 2FA, netwerkbeveiliging en endpoint-protectie.</li>
                                            <li>Processen en beleid rondom gegevensbescherming en dataverwerking.</li>
                                            <li>Risico’s binnen uw IT-infrastructuur en beleid.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12 mb-4">
                                <div className="step_card card">
                                    <div className="card-body text-center">
                                        <h4 className="card-title">2. Regelgeving op maat</h4>
                                        <p className="card-text">Toegepast op uw branche en organisatie, geven we u een helder overzicht van:</p>
                                        <ul className="card-text" style={{ textAlign: "left"}} >
                                            <li>Welke regels op u van toepassing zijn (bijvoorbeeld AVG, NIS2, ISO-normen, etc.).</li>
                                            <li>Hoe u ervoor kunt zorgen dat uw organisatie deze regels naleeft.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12 mb-4">
                                <div className="step_card card">
                                    <div className="card-body text-center">
                                        <h4 className="card-title">3. Praktische adviezen en quick wins</h4>
                                        <p className="card-text">Direct implementeerbare stappen om uw compliance te verbeteren, met speciale aandacht voor:</p>
                                        <ul className="card-text" style={{ textAlign: "left"}}>
                                            <li>Data-privacy en incidentbeheer.</li>
                                            <li>Bewustwording en training van personeel.</li>
                                            <li>Toepassing van tools zoals Intune, Graylog, en Microsoft 365.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12 mb-4">
                                <div className="step_card card">
                                    <div className="card-body text-center">
                                        <h4 className="card-title">4. Toekomstgericht advies</h4>
                                        <p className="card-text">We zorgen dat uw compliance-strategie toekomstbestendig is door:</p>
                                        <ul className="card-text" style={{ textAlign: "left"}}>
                                            <li>Het opstellen van een verbeterplan.</li>
                                            <li>Periodieke monitoring en audits.</li>
                                            <li>Integratie met uw bredere cybersecuritybeleid.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="text-center col-lg-12 col-md-12 mb-4">
                                <Link onClick={ClickHandler} to={'/contact'} className="btn">
                                    <span className="btn_label" data-text="Praat met een expert">Praat met een expert</span>
                                    <span className="btn_icon">
                                            <i className="fa-solid fa-arrow-up-right"></i>
                                        </span>
                                </Link>
                            </div>

                        </div>
                    </div>
                </section>

                {/* Voordelen Section */}
                <section className="benefits_section section_space">
                    <div className="container">
                        <div className="heading_block text-center">
                            <h3 className="heading_text">Waarom kiezen voor Praeventor?</h3>
                        </div>
                        <div className="row">
                            <div className="col-lg-4 col-md-6 mb-4">
                                <div className="benefit_card card">
                                    <div className="card-body">
                                        <h4 className="card-title">Expertise in IT- en compliance-uitdagingen voor MKB en scale-ups</h4>
                                        <p className="card-text">Wij begrijpen de tijdsdruk, hoge kosten en onzekerheid waarmee organisaties kampen en bieden oplossingen die passen binnen uw budget.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 mb-4">
                                <div className="benefit_card card">
                                    <div className="card-body">
                                        <h4 className="card-title">Branche-specifieke oplossingen</h4>
                                        <p className="card-text">Of u nu actief bent in de zorg, financiële sector, of technologie, wij stemmen onze adviezen volledig af op uw behoeften.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 mb-4">
                                <div className="benefit_card card">
                                    <div className="card-body">
                                        <h4 className="card-title">Praktische aanpak</h4>
                                        <p className="card-text">Geen onnodig complexe jargon, maar concrete en uitvoerbare adviezen die direct resultaat opleveren.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <CtaSection />
            </main>
            <Footer />
            <Scrollbar />
        </Fragment>
    );
};

export default RequestComplianceConsult;
